import { slugify } from "../../utils/slugify.js";
import type { CategoryType } from "../CategoryType.js";
import type { Locale } from "../Locale.js";
import { categoryTypeNameMap } from "../names/categoryTypeNameMap.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCategoryPath(locale: Locale, categoryType: CategoryType): string {
	return getPathInLocale(locale, `/${slugify(categoryTypeNameMap[categoryType][locale])}`);
}
